export default "https://cdn-static.gokick.com/assets/34a72110398b299a93da730cfac0263ae4687154/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";